'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var styled = require('styled-components');
var ErrorBanner = require('../../../../../common/components/ErrorBanner.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Spacer = styled__default["default"].div.withConfig({
  componentId: "sc-1yzaq45-0"
})(["padding-bottom:1rem;"]);
const ClaimSummaryView = _ref => {
  let {
    submitClaimStatus
  } = _ref;
  const {
    claimsSummaryItemTitle,
    claimsSummarySubmitApiError
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, submitClaimStatus.error && !submitClaimStatus.loading && /*#__PURE__*/React__default["default"].createElement(Spacer, null, /*#__PURE__*/React__default["default"].createElement(ErrorBanner["default"], null, claimsSummarySubmitApiError)), /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    containerCustomStyle: {
      textAlign: 'center',
      marginBottom: '1rem'
    }
  }, claimsSummaryItemTitle));
};
var ClaimSummaryHeader = nthHookTranslations.withTranslationsProvider(ClaimSummaryView, {
  translationKeys: ['claimsSummaryItemTitle', 'claimsSummarySubmitApiError']
});

exports["default"] = ClaimSummaryHeader;
